import React from 'react';
import styled from "styled-components";
import Colours from "../../../../atoms/Colours";
import { tablet } from "../../../../atoms/MediaQueries";

export function DayNoteIcon(props: Props) {
  return (
    <Container />
  )
}

interface Props {
}

const Container = styled.div`
  position: absolute;
  border-radius: 100%;
  background-color: ${Colours.green};
  filter: drop-shadow(0px 2px 2px rgba(63, 67, 74, 0.15));
  top: 42px;
  right: 8px;
  height: 10px;
  width: 10px;
  @media (${tablet}) {
    bottom: 6px;
  }
`
